export var getLastModifiedDate = function (timestamp) {
    var date = new Date(timestamp);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();
    return "".concat(month, "/").concat(day, "/").concat(year);
};
